<template>
  <div class="page-clue">
    <crm-panel :title="'政府客户列表'">
      <!-- 操作按钮 -->
      <div class="page-buttons">
        <crm-button
          v-if="auth.govAdd && auth.govAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="toAdd()"
        >
        </crm-button>
        <crm-button
          v-if="auth.govExport && auth.govExport.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="form" :inline="true" :model="search">
          <el-form-item label="">
            <el-select
              clearable
              v-model="search.inspectQuality"
              @change="handleSearch()"
              placeholder="考察性质"
            >
              <el-option
                v-for="item in investigationNature"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-select
              clearable
              v-model="search.inspectType"
              @change="handleSearch()"
              placeholder="考察类别"
            >
              <el-option
                v-for="item in investigatType"
                :label="item.name"
                :value="item.uid"
                :key="item.uid"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              value-format="yyyy-MM-dd"
              :editable="false"
              v-model="search.time"
              @change="handleSearch()"
              type="daterange"
              range-separator="至"
              start-placeholder="考察日期始"
              end-placeholder="考察日期止"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="search.input"
              class="input-with-select"
            >
              <el-select v-model="search.type" slot="prepend">
                <el-option
                  v-for="item in searchType"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                >
                </el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="governmentData && governmentData.results"
        border
        v-loading="loading"
        fit
        height="100%"
        style="width: 100%"
      >
        <el-table-column prop="inspectDate" width="100" label="考察日期" align="center">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="客户" width="200" align="center">
          <template slot-scope="{ row }">
            <span
              class="link"
              @click="toDetail(row)"
              v-if="auth.govDetailTab && auth.govDetailTab.toggleStatus"
            >
              {{ row.name }}
            </span>
            <span v-else>
              {{ row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="leader"
          width="200"
          label="主要领导"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="inspectNumber" width="100" align="center" label="考察人数">
        </el-table-column>
        <el-table-column prop="inspectQualityName" align="center" label="考察性质">
        </el-table-column>
        <el-table-column
          prop="inspectTypeName"
          width="100"
          align="center"
          label="考察类别"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="inspectPurpose"
          align="center"
          width="200"
          label="考察目的"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="lines4BusiName"
          width="100"
          align="center"
          label="业务线"
        >
        </el-table-column>
        <el-table-column fixed="right" width="120" align="center" label="操作">
          <template slot-scope="{ row }">
            <el-button
              v-if="auth.govUpdate && auth.govUpdate.toggleStatus"
              @click="toEdit(row)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            <el-button
              v-if="auth.govDelete && auth.govDelete.toggleStatus"
              @click="delCus(row)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 客户列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pagenation.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="(governmentData && governmentData.totalCount) || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <add
      :visible="addVisible"
      @close="addVisible = false"
      @success="handleSearch()"
    ></add>
    <edit
      :visible="editVisible"
      :id="rowId"
      @close="editVisible = false"
      @success="handleGetListData()"
    >
    </edit>
    <detail
      v-if="detailVisible"
      :visible="detailVisible"
      :id="rowId"
      @close="detailVisible = false"
      @refresh="handleGetListData()"
    ></detail>
  </div>
</template>

<script>
/* eslint-disable */
import { mapActions, mapGetters } from "vuex";
import { downloadByUrl, isEmptyObj } from "@/scripts/utils";
import CrmPanel from "@/components/base/crmPanel";
import CrmButton from "@/components/base/crmButton";
import Add from "@/components/business/customer-government/add";
import Edit from "@/components/business/customer-government/edit";
import Detail from "@/components/business/customer-government/detail";

export default {
  components: {
    CrmPanel,
    CrmButton,
    Add,
    Edit,
    Detail,
  },
  filters: {
    statusFilter(val) {
      const list = [
        {
          label: "待处理",
          value: 0,
        },
        {
          label: "跟进中",
          value: 1,
        },
        {
          label: "已转换",
          value: 2,
        },
        {
          label: "失效",
          value: 3,
        },
        {
          label: "其他",
          value: 4,
        },
      ];
      return list.find((item) => item.value === val).label;
    },
  },
  data() {
    return {
      loading: false,
      search: {
        inspectQuality: null,
        inspectType: null,
        time: [],
        type: "name",
        input: null,
      },
      pagenation: {
        pageSize: 10,
        pageNumber: 1,
      },
      searchType: [
        {
          label: "客户",
          value: "name",
        },
        {
          label: "考察人员",
          value: "inspectPeople",
        },
        {
          label: "考察申请人",
          value: "inspectApplicant",
        },
        {
          label: "接待人",
          value: "receptionPeople",
        },
        {
          label: "去访人",
          value: "visitPeople",
        },
      ],
      addVisible: false,
      editVisible: false,
      rowId: null,
      detailVisible: false,
    };
  },
  computed: {
    ...mapGetters({
      auth: "authority/auth",
      investigationNature: "common/investigationNature",
      investigatType: "common/investigatType",
      governmentData: "customer/governmentData",
      allSalesman: "clue/allSalesman",
      detail: "customer/governmentDetail",
    }),
  },
  methods: {
    ...mapActions({
      getGovernmentDetail: "customer/getGovernmentDetail",
      getInvestigationNature: "common/getInvestigationNature",
      getInvestigationCategory: "common/getInvestigationCategory",
      getGovernmentData: "customer/getGovernmentData",
      deleteGovernmentCus: "customer/deleteGovernmentCus",
      getAllSalesman: "clue/getAllSalesman",
      saveSalesmanChange: "clue/saveSalesmanChange",
    }),
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.handleGetListData();
    },
    handleGetListData() {
      this.loading = true;
      this.getGovernmentData({
        ...this.handleParams(),
        ...this.pagenation,
      }).finally(() => {
        this.loading = false;
      });
    },
    handleParams() {
      this.search.name = null;
      this.search.inspectPeople = null;
      this.search.inspectApplicant = null;
      this.search.receptionPeople = null;
      this.search.visitPeople = null;
      if (this.search.type) this.search[this.search.type] = this.search.input;
      this.search.inspectStartDate = this.search.time ? this.search.time[0] : null;
      this.search.inspectEndDate = this.search.time ? this.search.time[1] : null;
      const { time, input, type, ...otherParams } = this.search;
      return otherParams;
    },
    handleExport() {
      const notify = this.$notify.info("正在导出中……");
      const params = this.handleParams();
      let url = "/api/govInspect/export?";
      Object.keys(params).forEach((item) => {
        if (params[item]) url += `${item}=${params[item]}&`;
      });
      downloadByUrl(url);
      notify.close();
    },
    delCus(row) {
      this.$confirm("此操作将永久删除该客户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.deleteGovernmentCus({ id: row.id })
            .then(() => {
              this.handleGetListData();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    toAdd() {
      this.addVisible = true;
    },
    async toDetail(row) {
      await this.getGovernmentDetail({ id: row.id }).then((res) => {
        if (!isEmptyObj(this.detail)) {
          this.rowId = row.id;
          this.detailVisible = true;
        }
      });
    },
    toEdit(row) {
      this.rowId = row.id;
      this.editVisible = true;
    },
    toChangeSalesman(row) {
      if (!this.allSalesman.length) this.getAllSalesman();
      this.salesmanForm.id = row.id;
      this.salesmanForm.now = row.salesmanName;
      this.salesmanVisible = true;
    },
    handleSaveSalesmanChange() {
      const { now, ...otherParams } = this.salesmanForm;
      this.saveSalesmanChange(otherParams)
        .then(() => {
          this.salesmanVisible = false;
          this.$message.success("替换成功！");
          this.handleGetListData();
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetListData();
    },
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetListData();
    },
  },
  created() {
    this.handleSearch();
    this.getInvestigationNature({
      pageNumber: 1,
      pageSize: 100,
      code: "category_inspect_quality",
    });
    this.getInvestigationCategory({
      pageNumber: 1,
      pageSize: 100,
      code: "category_inspect_type",
    });
  },
};
</script>

<style lang="less">
@import "~@/styles/const.less";

.page-clue {
  display: flex;
  flex: 1;
  width: 100%;
}
</style>
